import React from 'react';

const TableHeader = ({ title }) => {
    return (
        <h2 className='text-body2_600 text-black'>{title}</h2>
    );
};

export default TableHeader;